import { render, staticRenderFns } from "./ListSanitaryCompanies.vue?vue&type=template&id=2ca16b8e&"
import script from "./ListSanitaryCompanies.vue?vue&type=script&lang=js&"
export * from "./ListSanitaryCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca16b8e')) {
      api.createRecord('2ca16b8e', component.options)
    } else {
      api.reload('2ca16b8e', component.options)
    }
    module.hot.accept("./ListSanitaryCompanies.vue?vue&type=template&id=2ca16b8e&", function () {
      api.rerender('2ca16b8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/61221000-4/components/ListSanitaryCompanies.vue"
export default component.exports